module.exports = __webpack_public_path__ + "/images/ln-hero-af-bodi.5bca6ff.png";